require('./speech-recognition-tink.scss');

export class SpeechRecognitionTinkController {
  validate(config) {
    let errors = {};
    let tinkoff = config.tinkoff;

    if (!tinkoff || !tinkoff.api_key) {
      errors.tinkoff_api_key = gettext('Обязательное поле');
    }
    if (!tinkoff || !tinkoff.secret_key) {
      errors.tinkoff_secret_key = gettext('Обязательное поле');
    }

    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/speech/speech-recognition-tink.js